import {asideViews as witnessAsideViews} from "joynt/components/Witness";

export default {
    ...witnessAsideViews
}